import { useEffect, lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Lenis from 'lenis'
import { useReducedMotion } from 'framer-motion'
import { I18nProvider } from './lib/i18n'
import Landing from './pages/Landing'

// The app tool (maplibre, the whole console) is lazy → keeps the landing bundle light.
const AppTool = lazy(() => import('./pages/AppTool'))
// Full-screen satellite carbon map — public booth demo, static baked data only. Routed here
// (not inside AppTool) so it skips the auth probe + light app theme and loads standalone.
const CarbonMap = lazy(() => import('./pages/CarbonMap'))

function SmoothScroll() {
  const reduced = useReducedMotion()
  const loc = useLocation()
  useEffect(() => {
    // Lenis only on the landing — the app tool uses fixed-height panels with their own scroll.
    if (reduced || loc.pathname.startsWith('/app')) return
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true })
    let raf = 0
    const loop = (t: number) => {
      lenis.raf(t)
      raf = requestAnimationFrame(loop)
    }
    raf = requestAnimationFrame(loop)
    return () => {
      cancelAnimationFrame(raf)
      lenis.destroy()
    }
  }, [reduced, loc.pathname])
  return null
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <SmoothScroll />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app/carbon-map" element={<Suspense fallback={null}><CarbonMap /></Suspense>} />
          <Route path="/app/*" element={<Suspense fallback={null}><AppTool /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  )
}
